export default __webpack_public_path__ + "static/media/pep-banner.09caa207.webp";